import axios from 'axios';

const adminUrl = process.env.VUE_APP_ADMIN_URL;

function headers() {
  const accessToken = JSON.parse(localStorage.getItem('accessToken'));
  return { Authorization: `Bearer ${accessToken}` };
}

export default class ContractRenewalsService {
  /**
   * Contratos por urgencia de renovación, con el MRR en juego y su adopción.
   * Los filtros vacíos se omiten para no mandar parámetros nulos.
   * @param {{ window?: string, status?: string, lineaNegocio?: string, search?: string }} filtros
   * @returns {Promise<{status: string, data?: {summary: object, rows: object[]}}>}
   */
  static async getRenewals({ window, status, lineaNegocio, search } = {}) {
    try {
      const params = {};
      if (window) params.window = window;
      if (status) params.status = status;
      if (lineaNegocio) params.lineaNegocio = lineaNegocio;
      if (search) params.search = search;

      const response = await axios.get(`${adminUrl}/contract-renewals`, {
        params,
        headers: headers(),
      });
      if (response.data.status === 'ok') return response.data;
      return { status: 'error' };
    } catch {
      return { status: 'error' };
    }
  }
}
